import {PropsWithChildren} from 'react';

import {
  buildComponentInteractionId,
  InteractionComponentProps,
  InteractionContextValue,
} from '../../libs/shared/helpers/src/interaction/interactionHelpers';
import {InteractionTypesEnum} from '../../libs/shared/helpers/src/interaction/interactionTypes';
import {FrontEvent} from '../../libs/shared/helpers/src/react/reactHelpers';
import {trackEvent, TrackingTypesEnum} from './tracking';

/*
 * API.
 */

export function trackInteraction(type: InteractionTypesEnum, id: string, parentIds: ReadonlyArray<string>) {
  trackEvent(TrackingTypesEnum.INTERFACE_EVENT, type, {id, parentIds});
}

export function trackContextInteraction(
  type: InteractionTypesEnum,
  context: InteractionContextValue | undefined,
  interactionId: string,
) {
  const parentInteractionIds = context ? context.parentInteractionIds : [];
  trackInteraction(type, interactionId, parentInteractionIds);
}

export function trackComponentInteraction(
  type: InteractionTypesEnum,
  context: InteractionContextValue | undefined,
  props: PropsWithChildren<InteractionComponentProps>,
  event: FrontEvent,
) {
  const interactionId = buildComponentInteractionId(props, event);
  if (!interactionId) {
    return;
  }

  trackContextInteraction(type, context, interactionId);
}
